export const getMessagingUrl = toLocalizedUrl =>
    toLocalizedUrl(`${window.origin}/messagingiframe`);
